import React from "react";
import {
  executeActions,
  getJourneyType,
  getWidgetSpecificProps,
  isTeslaMake
} from "@utils/index";

import { connect } from "react-redux";
import { MainContainer, SubHeading, Container, MainHeadingBottomText, SubHeadingContainer, SubHeadingBottomText, MainHeadingWrapper } from "./styles";
import { useOnload } from "@utils/useOnLoad";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import Edit from "@components/Edit";
import Modal from "@components/modal";
import IDVModal from "@components/IDVModal";
import { convertToLakh } from "@utils/inrFormatter";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const PlansPageHeading = (props: any) => {
  const {
    text,
    is_visible,
    styles,
    actions,
    subHeading,
    modalProps,
    price,
    mainHeadingBottomText,
    subHeadingBottomText,
    vehicleMake
  } = props;

  const { on_load, on_click, on_edit_button_click, on_modal_load } = actions || {};
  const [showModal, setShowModal] = React.useState(false);
  const shouldLockIdv =
    getJourneyType() === "new_car" && isTeslaMake(vehicleMake);

  useOnload({ on_load });
  const editModalHandler = () => {
    executeActions(on_edit_button_click);
    setShowModal(true);
  };

  const onClickEffect = () => {
    setShowModal(false);
  };


  return is_visible ? (
    <Container>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        lockBackgroundInteraction={props.lockBackgroundInteraction}
      >
        <IDVModal
          {...modalProps}
          handleUpdateModal={on_click}
          onclickEffect={onClickEffect}
          onModalLoad={on_modal_load}
        />
      </Modal>
     <MainHeadingWrapper>
      <MainContainer
        className="page-heading"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {mainHeadingBottomText && (
        <MainHeadingBottomText>
          {mainHeadingBottomText}
        </MainHeadingBottomText>
        )}
      </MainHeadingWrapper> 
      <SubHeadingContainer>
        <Flex justifyContent="space-between" alignItems="center" style={{ flex: "1" }}>
          <SubHeading
            dangerouslySetInnerHTML={{
              __html: `${subHeading}<b>${convertToLakh(price)} lakh</b>`
            }}
          />
          {!shouldLockIdv && <Edit clickHandler={editModalHandler} />}
        </Flex>
        {subHeadingBottomText && (
          <SubHeadingBottomText dangerouslySetInnerHTML={{
            __html: subHeadingBottomText
          }}/>
        )}
      </SubHeadingContainer>
    </Container>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(PlansPageHeading);
